export const sr = {
  common: {
    appName: "eZDRAVLJE",
    search: "Pretraži",
    searchPlaceholder: "Pretraži aplikaciju...",
    favorites: "Favoriti",
    notifications: "Obaveštenja",
    noNewNotifications: "Nema novih obaveštenja",
    messages: "Poruke",
    cart: "Korpa",
    logout: "Odjavi se",
    session: "Sesija",
    settings: "Podešavanja",
    theme: "Tema",
    language: "Jezik",
    inDevelopment: "U razvoju",
    loading: "Učitavanje...",
    save: "Sačuvaj",
    cancel: "Otkaži",
    confirm: "Potvrdi",
    delete: "Obriši",
    edit: "Uredi",
    close: "Zatvori",
    back: "Nazad",
    next: "Sledeće",
    submit: "Pošalji",
    activate: "Aktiviraj",
    register: "Registruj se",
    apply: "Prijavi se",
    book: "Rezerviši",
    pay: "Plati",
    download: "Preuzmi",
    upload: "Otpremi",
    share: "Podeli",
    view: "Pogledaj",
    filter: "Filtriraj",
    sortBy: "Sortiraj po",
    all: "Sve",
    active: "Aktivan",
    inactive: "Neaktivan",
    pending: "Na čekanju",
    completed: "Završen",
    cancelled: "Otkazan",
    free: "Besplatno",
    noData: "Nema podataka",
    error: "Greška",
    tenantScopeDenied: "Pristup je ograničen na nivou klinike.",
    success: "Uspeh",
    required: "Obavezno",
    optional: "Opciono",
    eur: "EUR",
  },
  appointment_created: "Termin je uspesno kreiran i dodat u klinicki raspored.",
  laboratory_case_created: "Laboratorijski slucaj je kreiran i ceka obradu.",
  laboratory_results_ready: "Laboratorijski rezultati su spremni za klinicki pregled.",
  laboratory_case_delivered: "Laboratorijski rezultati su dostavljeni pacijentu.",
  payment_success: "Placanje je uspesno izvrseno.",
  LARGE_TRANSACTION: "Otkrivena je velika transakcija koja zahteva pažnju.",
  service_subscription_activated: "Pretplata na modul je aktivirana.",
  service_subscription_expired: "Pretplata na modul je istekla.",
  inventory_incident_reported: "Prijavljen je incident sa opremom.",
  business_invoice_created: "Kreirana je nova B2B faktura.",
  verification: {
    requestedSuccess: "Vas zahtev je poslat administratoru.",
    requirementsMissing: "Da biste zatrazili verifikaciju, morate biti clan verifikovane klinike.",
  },
  security: {
    setPin: "Postavite PIN",
    pinRequired: "Molimo postavite PIN da biste otkljucali uredjivanje profila.",
    pinSuccess: "PIN je sacuvan.",
  },
  media: {
    uploading: "Otpremanje fajla...",
    allowedImageFormat: "Dozvoljeni format: JPG, PNG",
    uploadSuccess: "Fajl je uspesno sacuvan",
    uploadFile: "Otpremi fajl",
    dropOrClick: "Kliknite ili prevucite fajl ovde",
  },
  showcase: {
    hero: {
      badge: "✦ Zdravstvena platforma #1 · Kosovo",
      reserve: "Rezervisi sada",
      dotsLabel: "Izaberi slajd",
      slides: {
        speed: {
          title: "Rezervisite online lekarski pregled",
          subtitle: "Pronadjite slobodan termin, izaberite lekara i potvrdite posetu za nekoliko sekundi.",
          button: "Rezervisi sada",
        },
        nearby: {
          title: "Pronadjite najblize specijaliste",
          subtitle: "Pretrazujte po gradu, specijalnosti i udaljenosti da brzo nadjete najblizu negu.",
          button: "Pronadji specijalistu",
        },
        vault: {
          title: "Vas medicinski karton, 100% siguran",
          subtitle: "Izvestaji, analize i klinicka istorija cuvaju se u zasticenom licnom Vault-u.",
          button: "Otvori moju istoriju",
        },
      },
    },
  },
  ads: {
    selectOwner: "Izaberite vlasnika za placanje",
    selectPriority: "Izaberite prioritet",
    errorOwnerNotFound: "Nalog za placanje nije pronadjen. Izaberite vazeceg vlasnika iz liste.",
    requestAd: "Zatrazi reklamu",
    platformInternal: "Reklama platforme",
    pendingApproval: "Na cekanju",
    pendingPayment: "Reklama je kreirana i ceka placanje fakture.",
    requestSent: "Zahtev je poslat. Platite fakturu u sekciji faktura da bi bio pregledan.",
    waitingApproval: "ceka odobrenje",
    marketingTab: "Marketing i promocija",
    marketing: "Marketing",
    payConfirm: "Da li ste sigurni da želite platiti ovu fakturu iz Wallet-a?",
    cancelSuccess: "Zahtev je uspešno otkazan.",
  },
  medimarket: {
    orderCompleted: "Porudzbina je zavrsena",
    walletPaymentCompleted: "Placanje je uspesno izvrseno iz Wallet-a.",
    trackingCode: "Kod za pracenje",
    requiresPrescription: "Potreban je medicinski recept",
  },
  themes: {
    lightFlat: "Light",
    dark: "Dark",
    gradientLight: "Gradient",
  },
  languages: {
    sq: "SQ",
    en: "EN",
    sr: "SR",
    tr: "TR",
  },
  roles: {
    business: "Biznis",
    doctor: "Lekar",
    specialist: "Specijalista",
    technician: "Tehničar",
    patient: "Pacijent",
    admin: "Administracija",
    superadmin: "Superadmin",
    student: "Student",
    guest: "Gost",
    none: "Nema aktivnog profila",
  },
  nav: {
    dashboard: "Kontrolna tabla",
    corporateDashboard: "Korporativna kontrolna tabla",
    search: "Pretraži",
    patientHome: "Moja stranica",
    professionalPanel: "Moj panel",
    appointments: "Pregledi",
    monitoring: "Praćenje",
    familyCare: "Porodična briga",
    clinicalHistory: "Klinička istorija",
    laboratory: "Laboratorija",
    labResults: "Rezultati",
    labAdmin: "Panel laboranta",
    serviceHub: "Servisni centar",
    inventory: "Inventar",
    jobs: "Ponude za posao",
    insurance: "Osiguranje",
    events: "Događaji",
    familyDashboard: "Porodični panel",
    wallet: "Novčanik",
    businessWallet: "Poslovni novčanik",
    medimarket: "Medimarket",
    cart: "Korpa",
    seller: "Moja prodavnica",
    registerBusiness: "Registruj biznis",
    myBlog: "Moj blog",
    adsManagement: "Upravljanje oglasima",
    invoices: "Fakture",
    messages: "Poruke",
    departments: "Odeljenja",
    hospitalBeds: "Kreveti",
    hospitalAdmissions: "Prijemi",
    admin: "Admin",
    verifyDoctors: "Verifikacija lekara",
    account: "Nalog",
    businesses: "Poslovanja",
    myClinic: "Moja klinika",
    reportTemplate: "Šablon izveštaja",
  },
  professionalSettings: {
    tabs: { profile: "Profil", timeline: "Obrazovanje i iskustvo", skills: "Veštine i jezici", social: "Društvene mreže", weekly: "Nedeljni raspored", exceptions: "Izuzeci", security: "Bezbednost" },
    status: { publicActive: "Javni CV je aktivan", publicInactive: "Javni CV nije aktivan", verified: "Verifikovan", pendingVerification: "Verifikacija na čekanju" },
    actions: { viewPublicCv: "Pogledaj javni CV", marketingView: "Marketinški prikaz" },
  },
  invoices: {
    labels: { status: "Status" },
    status: { paid: "Plaćeno", unpaid: "Neplaćeno", pending: "Na čekanju", failed: "Neuspešno", cancelled: "Otkazano" },
  },
  modules: {
    connecting: "Ovaj modul je u fazi povezivanja",
    appointments: "Medicinski pregledi",
    monitoring: "Zdravstveno praćenje",
    laboratory: "Laboratorija",
    insurance: "Zdravstveno osiguranje",
    events: "Događaji i webinari",
    jobs: "Platforma za zapošljavanje",
    inventory: "Medicinski inventar",
    serviceHub: "Servisni centar",
    wallet: "Digitalni novčanik",
    medimarket: "Medicinsko tržište",
    messages: "Poruke",
    clinical: "Klinička istorija",
    family: "Porodična briga",
    imaging: "Medicinska imidžing",
  },
  wallet: {
    cardLink: { title: "Bankovna kartica", connect: "Poveži karticu", change: "Promeni karticu", expires: "ističe", description: "Za brza plaćanja i fakture." },
    title: "Digitalni novčanik",
    eyebrow: "E-novčanik",
    financialTitle: "Finansijski novčanik",
    financialDescription: "Stanje, analitika i plaćanja se upravljaju u realnom vremenu.",
    notFoundTitle: "Novčanik nije pronađen",
    notFoundDescription: "Stanje trenutno nije moguće učitati. Pokušajte ponovo uskoro.",
    balance: "Stanje",
    topUp: "Dopuni",
    history: "Istorija transakcija",
    noTransactions: "Nema transakcija",
    credit: "Kredit",
    debit: "Debit",
    completed: "Završeno",
    pending: "Na čekanju",
    failed: "Neuspešno",
    insufficientFunds: "Nedovoljno sredstava u novčaniku.",
    invoicePaid: "Faktura je uspešno plaćena.",
    paymentSuccess: "Plaćanje je uspešno izvršeno.",
    totalBalance: "Ukupno stanje",
    myQrCode: "Moj QR kod",
    transactions: "Transakcije",
    activeSessions: "Aktivne sesije",
    activeRefs: "Aktivne reference",
    qrSubtitle: "Skenirajte za brze transfere",
  },
  billing: {
    b2bInvoices: "B2B SaaS fakture",
    vat: "PDV",
    paymentSuccessful: "Plaćanje je uspešno izvršeno.",
  },
  auth: {
    resetEmailSent: "Ako nalog postoji, email sa uputstvima je poslat.",
    passwordChangedSuccess: "Lozinka je uspešno promenjena. Sada se možete prijaviti.",
  },
  errors: {
    VERIFIED_PROFILE_REQUIRED: "Vaš nalog je na pregledu. Objavljivanje će biti omogućeno nakon verifikacije.",
    INSUFFICIENT_FUNDS: "Nemate dovoljno sredstava u novčaniku za ovu radnju.",
    ACCESS_DENIED: "Nemate autorizaciju za pristup ovom delu.",
    ALREADY_EXISTS: "Ova informacija već postoji u sistemu.",
    NOT_FOUND: "Traženi resurs nije pronađen.",
    generic: "Došlo je do greške. Molimo pokušajte ponovo.",
    network: "Problem sa vezom. Proverite internet.",
    unauthorized: "Sesija je istekla. Molimo prijavite se ponovo.",
    notFound: "Stranica nije pronađena.",
    insufficientFunds: "Nedovoljno sredstava u novčaniku.",
    forbidden: "Nemate dozvolu za ovu radnju.",
    invalidFileType: "Otpremeljeni fajl nije validna slika ili video.",
    reportNotFound: "Medicinski izvestaj nije pronadjen.",
    REPORT_REQUIRED_FIELDS_MISSING: "Popunite obavezna polja pre potpisivanja.",
    fieldLocked: "Zakljucano polje ne moze biti obrisano.",
    clinicalAccessDenied: "Pristup odbijen: ovaj deo sadrzi poverljive klinicke podatke.",
    retentionPolicyActive: "Finalizovani medicinski izvestaji ne mogu biti obrisani zbog zakonskog roka cuvanja.",
    retention_policy_active: "Finalizovani medicinski izvestaji ne mogu biti obrisani zbog zakonskog roka cuvanja.",
    hospitalMetadataRequired: "Bolnicki izvestaj ne moze biti potpisan bez podataka o prijemu.",
    bedAlreadyOccupied: "Krevet je vec zauzet.",
    invalidResetToken: "Ovaj link nije validan ili je istekao.",
  },

  pages: {
    lab:       { eyebrow: 'Laboratorija',            title: 'Rezultati analiza',        description: 'Najnoviji klinički podaci sa statusima izračunatim od strane sistema.' },
    events:    { eyebrow: 'Medicinska platforma',    title: 'Događaji i webinari',      description: 'Uživo i snimljeni medicinski webinari, konferencije i obuke.' },
    jobs:      { eyebrow: 'Medicinska platforma',    title: 'Ponude za posao',          description: 'Mogućnosti zapošljavanja u zdravstvenom sektoru.' },
    insurance: { eyebrow: 'Zdravstveno osiguranje',  title: 'Portal osiguranja',        description: 'Vaša polisa i pokriće od kosovskih partnera osiguranja.' },
    wallet:    { eyebrow: 'Digitalni novčanik',      title: 'Novčanik',                 description: 'Upravljajte stanjem, transakcijama i medicinskim plaćanjima.' },
    favorites: { eyebrow: 'Favoriti',                title: 'Moji favoriti',            description: 'Lekari, klinike i proizvodi koje ste sačuvali.' },
    inventory: { eyebrow: 'Medicinska oprema',       title: 'Smart inventar',           description: 'Upravljanje medicinskom opremom sa QR i praćenjem životnog ciklusa.' },
    serviceHub:{ eyebrow: 'Servisni centar',         title: 'Service Hub',              description: 'Aktivirajte i upravljajte modulima platforme za vašu kliniku.' },
    monitoring:{ eyebrow: 'Zdravstveno praćenje',    title: 'Praćenje',                 description: 'Praćenje zdravstvenih parametara u realnom vremenu.' },
  },

  posts: {
    patientQuestion: "Pitanje pacijenta",
    professionalPost: "Profesionalna objava",
    summaryLabel: "Kratak sažetak",
    officialBadge: "Zvanični članak",
    patientBadge: "Pitanje pacijenta",
    rejectionReason: "Razlog odbijanja",
    unverifiedAlert: "Vaša objava čeka odobrenje",
    commentRestricted: "Samo medicinsko osoblje moze komentarisati profesionalne objave.",
    rejectionTitle: "Odbijeno",
    status: {
      published: "Objavljeno",
      pending: "Ceka odobrenje",
      rejected: "Odbijeno",
      draft: "Nacrt",
      scheduled: "Zakazano",
      expiring: "Istice",
      expired: "Isteklo",
    },
    rejectionFallback: "Objava zahteva korekciju pre objavljivanja.",
    moderation: {
      title: "Moderiranje objava",
      description: "Objave ovde čekaju pregled i u Showcase izlaze tek nakon odobrenja.",
      empty: "Nema objava na čekanju za pregled.",
      archiveEmpty: "Nema odobrenih ili odbijenih objava.",
      untitled: "Bez naslova",
      approvePublish: "Odobri i objavi",
      reject: "Odbij",
      rejectTitle: "Odbij objavu",
      rejectDescription: "Izaberite razlog koji će biti prikazan autoru. Odbijanje ne briše objavu.",
      extraNote: "Dodatna napomena za autora",
      rejectWithReason: "Odbij sa razlogom",
      tabs: { pending: "Na čekanju", archive: "Aktivne" },
      reasons: {
        inaccurate: "Netačna informacija",
        unethical: "Neetički sadržaj",
        promotional: "Nedozvoljen promotivni sadržaj",
      },
    },
  },

  access: {
    unauthorized_role: "Ova uloga nema pristup kliničkom dosijeu pacijenta.",
    relationship_required: "Potreban je klinički odnos ili aktivna dozvola pacijenta.",
    requestNewGrant: "Zatraži novu dozvolu za pristup",
    clinicalForbidden: {
      title: "Pristup zabranjen",
      description: "Ovaj odeljak sadrži privatne kliničke podatke.",
    },
    moduleInactive: {
      title: "Modul još nije aktiviran",
      description: "Backend trenutno prijavljuje ovaj modul kao neaktivan.",
    },
    profileRequired: {
      title: "Izaberite aktivan profil",
      description: "Ovaj odeljak zavisi od konteksta profila koji backend prijavljuje za vašu sesiju.",
    },
    permissionMissing: {
      title: "Nedostaje potrebna dozvola",
      description: "Ovaj odeljak zahteva: {{permissions}}. Obratite se administratoru.",
    },
    denied: {
      title: 'Izolovana sekcija',
      description: 'Ovo je izolovana sekcija {{role}}. Nemate autorizaciju za ovaj kontekst.',
    },
    clinicalIsolation: {
      title: 'Klinički pristup blokiran',
      description: 'Administratori nemaju pristup kliničkim podacima (Ustav §III). Vaša uloga: {{role}}.',
    },
    notVerified: 'Vaš profil još nije verifikovan od strane administratora.',
    technicianBlock: 'Zaštita privatnosti: Ova sekcija (Agenda/Workbench) rezervisana je samo za specijalističko medicinsko osoblje.',
    pendingVerification: 'Verifikacija na čekanju',
    switchBusiness: 'Pređi na poslovni režim',
    switchClinical: 'Povratak na klinički režim',
    businessMode: 'Poslovni režim',
    clinicalMode: 'Klinički režim',
  },
  admin: {
    title: "Kontrolna soba",
    auditTrail: "Evidencija aktivnosti",
    allDomains: "Svi domeni",
    allSeverities: "Svi nivoi",
    recentEvents: "nedavni događaji",
    noEvents: "Nema evidentiranih događaja.",
    growth: { title: "Novi nalozi - poslednjih 7 dana", noData: "Nema registracija u poslednjih 7 dana.", newAccounts: "Novi nalozi" },
    kpi: { totalAccounts: "Ukupno naloga", activeAccounts: "aktivni nalozi u sistemu", appointments: "Termini (mesec)", appointmentsSub: "završeni termini", volume: "Finansijski obim", volumeSub: "mesečne transakcije" },
  },
  superadmin: {
    verifyBusiness: "Verifikuj",
    moduleApprovals: "Odobrenja modula",
    activateModule: "Aktiviraj modul",
  },
  business: {
    licenseUsage: "Korišćenje licenci",
    doctorLimit: "Ograničenje lekara",
    usedSeats: "Iskorišćene licence",
  },
  appointments: {
    title: "Medicinski termini",
    book: "Rezerviši termin",
    upcoming: "Predstojeći termini",
    past: "Prethodni termini",
    confirmed: "Potvrđen",
    requested: "Zahtev poslat",
    completed: "Završen",
    cancelled: "Otkazan",
    noAppointments: "Nema planiranih termina",
    selectDoctor: "Izaberite lekara",
    selectDate: "Izaberite datum",
    selectTime: "Izaberite vreme",
    confirmPayment: "Potvrdi i plati novčanikom",
    insufficientFunds: "Nedovoljno sredstava",
    addFunds: "Dodaj sredstva ->",
  },
  search: {
    title: "Pametna pretraga",
    placeholder: "Pretražite lekara, kliniku ili specijalnost...",
    placeholderShort: "Pretražite lekara, kliniku...",
    verified: "Verifikovan",
    viewProfile: "Pogledaj profil",
    publicProfile: "Javni profil je aktivan",
    noResults: "Nema rezultata.",
    filters: "Filteri",
    advancedFilters: "Napredni filteri",
    radius: "Radijus (km)",
    gender: "Pol",
    any: "Bilo koji",
    female: "Žensko",
    male: "Muško",
    tabs: { all: "Sve", professionals: "Lekari", clinics: "Klinike" },
    cities: { all: "Svi gradovi", prishtina: "Priština", prizren: "Prizren", gjilan: "Gnjilane", peja: "Peć", mitrovica: "Mitrovica" },
  },
  messagesPage: {
    eyebrow: "Bezbedan MSN",
    title: "Poruke",
    description: "Privatni razgovori pacijent-profesionalac, otvoreni samo uz klinički kontekst.",
    reconnecting: "Veza je prekinuta. Ponovni pokušaj {{current}}/{{max}}...",
    failedReconnect: "Veza nije uspela nakon 5 pokušaja. Osvežite stranicu.",
  },
  events: {
    title: "Događaji i vebinari",
    register: "Registruj se",
    registered: "Registrovani ste",
    registering: "Registracija...",
    full: "Nema slobodnih mesta.",
    free: "Besplatno",
    online: "Online",
    inPerson: "Uživo",
    hybrid: "Hibridno",
    webinar: "Vebinar",
    conference: "Konferencija",
    training: "Obuka",
    workshop: "Radionica",
    seminar: "Seminar",
    noEvents: "Nema aktivnih događaja",
  },
  jobs: {
    title: "Platforma za zapošljavanje",
    apply: "Prijavi se",
    applying: "Prijavljivanje...",
    applied: "Prijavljeno",
    fullTime: "Puno radno vreme",
    partTime: "Nepuno radno vreme",
    contract: "Ugovor",
    onSite: "U objektu",
    remote: "Na daljinu",
    hybrid: "Hibridno",
    salary: "Plata",
    noOffers: "Nema aktivnih ponuda",
  },
};

